<template>
    <div id="personal-container">
        <MdTitle v-bind:Text="$t('userHeader.GeneralInfo')" v-bind:isSubtitle="true" v-bind:Name="'T_INFO_SUBTITLE'"/>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.initial"                    
                    v-bind:Label="$t('Patient.Initial')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="1"
                    v-bind:Id="'input_e_ini'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.eMail"                    
                    v-bind:Label="$t('Shared.Email')"  
                    v-bind:TypeProp="'email'" 
                    v-bind:isRequired="false"
                    v-bind:isValid="this.emailValid"
                    v-bind:MaxLengthProp="75"
                    v-bind:Id="'input_e_email'"
                />
            </b-col>
            </b-row>
            <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.address1"                    
                    v-bind:Label="$t('Shared.Address1')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="30"
                    v-bind:Id="'input_e_addrs1'"
                />
            </b-col> 
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.address2"                    
                    v-bind:Label="$t('Shared.Address2')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="30"
                    v-bind:Id="'input_e_addrs2'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.zip"                    
                    v-bind:Label="$t('Shared.Zip')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="10"
                    v-bind:Id="'input_e_zip'"
                />
            </b-col> 
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.city"                    
                    v-bind:Label="$t('Shared.City')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="25"
                    v-bind:Id="'input_e_city'"
                />
            </b-col>
            </b-row>
            <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.state"                    
                    v-bind:Label="$t('Shared.State')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="2"
                    v-bind:Id="'input_e_state'"
                />
            </b-col> 
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.county"                    
                    v-bind:Label="$t('employee.County')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="25"
                    v-bind:Id="'input_e_contry'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.country"                    
                    v-bind:Label="$t('Shared.Country')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="25"
                    v-bind:Id="'input_e_country'"
                />
            </b-col> 
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-model="editableItem.fax"                    
                    v-bind:Label="$t('Patient.LegalFax')"  
                    v-bind:isRequired="false"
                    v-bind:MaxLengthProp="15"
                    v-bind:Id="'input_e_lf'"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import validator from 'validator';
import Utils from '@/common/utils'

export default {
    name: 'PersonalPanel',
    props: {
        value: {
            type: Object,
            required: () => true
        },
        Mode: {
            type: Boolean,
            required: true
        },
        isReadOnly: {
            type: Boolean,
            default: false
        },
        
    },

    data() {
        const defaultPersonalProps = {
            initial: '',
            eMail: '',
            address1: '',
            address2: '',
            zip: '',
            city: '',
            state: '',
            county: '',
            country: '',
            fax: ''
        };

        return {
            editableItem: this.value || defaultPersonalProps,
            emailValid: false,
        }
    },

    methods: {
        validate_entries() {
            this.emailValid = (Utils.isNullOrEmptyString(this.editableItem.eMail) || validator.isEmail(this.editableItem.eMail));   
        
            return this.emailValid;
        },
    }
}
</script>